/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "primereact/button";
import { useEffect, useRef, useState } from "react";
import { Menu } from "primereact/menu";
import { MenuItem } from "primereact/menuitem";
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";
import { InputText } from "primereact/inputtext";
import {
  SORT_FILTER,
  STATUS_FILTER,
  INVOICE_ROLES,
} from "../../../../util/constants";
import { InputSwitch, InputSwitchChangeEvent } from "primereact/inputswitch";
import { ProgressSpinner } from "primereact/progressspinner";
import DataTableComponent, { ColumnOption } from "../../../common/DataTable";
import { Paginator, PaginatorPageChangeEvent } from "primereact/paginator";
import { Dialog } from "primereact/dialog";
import { EditButtonSVG } from "../../../../assets/SVGs/EditButtonSVG";
import { Toast } from "primereact/toast";
import { TableSortingSVG } from "../../../../assets/SVGs/TableSortingSVG";
import { getErrorMessage } from "../../../../helper/getResponseMessage";
import { showError, showSuccess } from "../../../../util/ShowStatus";
import axios from "../../../../util/axiosconfig";
import { MultiSelect } from "primereact/multiselect";
import { Calendar } from "primereact/calendar";
import { ROLES } from "../../../../util/roleNameConstants";
import {
  convertEpochtoDate,
} from "../../../../helper/DateConverters";
import { InputNumber } from "primereact/inputnumber";
import { AutoComplete } from "primereact/autocomplete";
import { useDebounce } from "../../../../util/debounce";
import FilterButton from "../../Work Time Log Management/common/FilterButton";
import { handleWeekChange } from "./HandleWeekChange";
import { extendTimeSheet } from "./fetchData";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import CustomSpinner from "../../../../util/CustomSpinner";
import { Timeline } from "primereact/timeline";
import { Card } from "primereact/card";

export interface TimeLogUser {
  userID?: string | null;
  firstName: string | null;
  lastName: string | null;
  DOB: any;
  DOJ: any;
  userEmail: string | null;
  displayName?: string;
  departments?: any;
  roleID: any;
  roleDisplayName?: string;
  leaves?: any;
  lineManagerID?: string | null;
  isActive: number;
  userStatusChangeHistory?: any[];
}

interface FormErrors {
  firstName: string | null;
  lastName: string | null;
  DOB: any;
  DOJ: any;
  userEmail: string | null;
  departments: any;
  roleID: any;
  leaves: any;
  lineManager: any;
}

interface Filters {
  displayName: string | null;
  manager: any;
  departments: any;
  status: "all" | "active" | "inactive";
}

interface Role {
  roleID: number;
  roleName: string;
  roleDisplayName: string;
  isActive: boolean;
  moduleID: number;
}

const AdminUserManagement = () => {
  const [usersLoading, setUsersLoading] = useState<boolean>(false);
  const [addExtendTimeSheetLoading, setAddExtendTimeSheetLoading] =
    useState<boolean>(false);
  const [statusFilter, setStatusFilter] = useState<string | null>("all");
  const [isDialogVisible, setIsDialogVisible] = useState<boolean>(false);
  const [formType, setFormType] = useState<string>("add");
  const [isAddButtonDisabled, setIsAddButtonDisabled] = useState(false);

  const [selectedManagerFilter, setSelectedManagerFilter] = useState<any>(null);
  const [selectedLineManager, setSelectedLineManager] = useState<any>(null);
  const [selectedUserRole, setSelectedUserRole] = useState<any>(null);
  const [users, setUsers] = useState<TimeLogUser[]>([]); // To hold the list of users
  const [lineManagersList, setLineManagersList] = useState<any>([]);
  const [filterLineManagers, setFilterLineManagers] = useState<any>([]);
  const [departments, setDepartments] = useState<any>([]);
  const [roles, setRoles] = useState<Role[]>([]);
  const [timeLogRoleIDs, setTimeLogRoleIDs] = useState<any>(null);
  const [selectedUserName, setSelectedUserName] = useState<any>(null);
  const [userNamesuggestions, setUserNameSuggestions] = useState<any>([]);
  const [allUsers, setAllUsers] = useState<any>([]);
  const [resetPwdLoading, setResetPwdLoading] = useState<boolean>(false);

  const [formValues, setFormValues] = useState<TimeLogUser>({
    firstName: null,
    lastName: null,
    DOB: null,
    DOJ: null,
    userEmail: null,
    departments: null,
    roleID: null,
    leaves: null,
    lineManagerID: null,
    isActive: 1,
  });
  const [filters, setFilters] = useState<Filters>({
    displayName: null,
    manager: null,
    departments: null,
    status: "all",
  });

  const [formErrors, setFormErrors] = useState<FormErrors>({
    firstName: null,
    lastName: null,
    DOB: null,
    DOJ: null,
    userEmail: null,
    departments: null,
    roleID: null,
    leaves: null,
    lineManager: null,
  });

  const [extendTimeSheetFormErrors, setExtendTimeSheetFormErrors] =
    useState<any>({
      name: null,
      startDate: null,
      endDate: null,
      extendHours: null,
    });

  const [sortFilter, setSortFilter] = useState<any>({
    sortField: "createdDate",
    sortOrder: false,
  });

  const [isStatusDialogVisible, setIsStatusDialogVisible] =
    useState<boolean>(false);
  const [statusChangeReason, setStatusChangeReason] = useState<string>("");
  const [pendingStatusChange, setPendingStatusChange] = useState<{
    userID: string;
    isActive: number;
  } | null>(null);
  const [statusChangeReasonError, setStatusChangeReasonError] = useState<
    string | null
  >(null);

  const [viewHistoryPopup, setViewHistoryPopup] = useState<boolean>(false);
  const [userStatusChangeActivity, setUserStatusChangeActivity] = useState<any>(
    []
  );
  const [selectedRowData, setSelectedRowData] = useState<any>(null);

  const [showExtendedTimesheet, setShowExtendedTimesheet] =
    useState<boolean>(false);
  const [showTimesheetLockDialog, setShowTimesheetLockDialog] =
    useState<boolean>(false);
  const [timesheetLockAction, setTimesheetLockAction] = useState<
    "lock" | "unlock"
  >("unlock");
  const [timesheetLockLoading, setTimesheetLockLoading] =
    useState<boolean>(false);
  const [extendTimeSheetData, setExtendTimeSheetData] = useState<any>(() => {
    const today = new Date();
    const utcDay = today.getUTCDay();
    const diffToMonday = today.getUTCDate() - utcDay + (utcDay === 0 ? -6 : 1);
    const monday = new Date(
      Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), diffToMonday)
    );
    const sunday = new Date(monday);
    sunday.setUTCDate(monday.getUTCDate() + 6);
    monday.setUTCHours(0, 0, 0, 0);
    sunday.setUTCHours(23, 59, 59, 999);
    return {
      name: null,
      userID: null,
      startDate: monday,
      endDate: sunday,
      extendHours: null,
    };
  });

  const [extendTimeSheetWeek, setExtendTimeSheetWeek] = useState<any>(() => {
    const today = new Date();
    const day = today.getDay();
    const diffToMonday = today.getDate() - day + (day === 0 ? -6 : 1); // Adjust for Monday as start
    const monday = new Date(today.setDate(diffToMonday));
    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6); // End on Sunday
    return [monday, sunday];
  });

  const [timesheetLockData, setTimesheetLockData] = useState<any>({
    name: null,
    userID: null,
    startDate: null,
    endDate: null,
  });

  const [timesheetLockFormErrors, setTimesheetLockFormErrors] = useState<any>({
    name: null,
    startDate: null,
    endDate: null,
  });

  const [selectedTimesheetLockDates, setSelectedTimesheetLockDates] =
    useState<any>([]);

  const [selectedDOB, setSelectedDOB] = useState<any>(null);
  const [selectedDOJ, setSelectedDOJ] = useState<any>(null);
  const [selectedRoleFilter, setSelectedRoleFilter] = useState<any>(null);
  const [isExporting, setIsExporting] = useState<boolean>(false);

  const [first, setFirst] = useState<number>(0);
  const [size, setSize] = useState<number>(10);
  const [totalRecords, setTotalRecords] = useState<number>(10); // To hold the total number of records

  const [resetUserId, setResetUserId] = useState<string | null>(null);

  const page = 0;

  const menu = useRef<Menu>(null);
  const toast = useRef<Toast>(null);

  const searchUserNameWithDebounce = useDebounce(
    filters?.displayName?.trim() ?? null
  );

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === " " || e.key === "Tab") {
      e.stopPropagation(); // Prevent focus shift or parent events
    }
  };

  const handleResetPassword = async (userData: any) => {
    try {
      setResetUserId(userData.userID); // Set the loading user ID
      setResetPwdLoading(true);
      const response = await axios.post("admin/resend-user-email", {
        userID: userData.userID,
      });
      setResetPwdLoading(false);
      showSuccess(response.data.Message, toast);
    } catch (error: any) {
      setResetPwdLoading(false);
      const errorMessage = getErrorMessage(error);
      showError(errorMessage, toast);
    }
  };

  const fetchUsers = async (page: number, size: number, type?: string) => {
    try {
      setUsersLoading(true);
      const params: any = {
        size,
        page,
        sortField: sortFilter.sortField,
        sortOrder:
          sortFilter.sortOrder === true ? SORT_FILTER.ASC : SORT_FILTER.DESC,
      };

      if (searchUserNameWithDebounce) {
        params.displayName = searchUserNameWithDebounce;
      }

      if (selectedManagerFilter) {
        params.lineManagerID = selectedManagerFilter.userID;
      }
      if (filters.departments) {
        params.departmentID = filters.departments.departmentID;
      }

      if (selectedRoleFilter && selectedRoleFilter.length !== 0) {
        params.roleID = selectedRoleFilter
          .map((role: any) => role.roleID)
          .join(",");
      }

      if (statusFilter !== "all") {
        params.isActive = statusFilter === "active" ? 1 : 0;
      }

      // const response = await axios.get<any>(`/tl-admin/user/list`, { params });

      // setUsers(response.data.result);
      // setTotalRecords(response.data.totalRecords); // Assuming the API returns the total count

      if (type === "export") {
        try {
          setIsExporting(true);
          const response = await axios.get("tl-admin/export-user", {
            params,
            responseType: "blob", // Important for binary data
          });

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.download = "user_report.csv";

          // Append to body and trigger download
          document.body.appendChild(link);
          link.click();

          // Clean up
          link.parentNode?.removeChild(link);
          window.URL.revokeObjectURL(url);
        } catch (error) {}
      } else {
        setUsersLoading(true);
        const response = await axios.get("tl-admin/user/list", { params });
        setUsers(response.data.result);
        setTotalRecords(response.data.totalRecords); // Assuming the API returns the total count
      }
      setIsExporting(false);
    } catch (error: any) {
      showError(
        error?.response?.data?.Message ?? "",
        toast,
        error?.message ?? ""
      );
    } finally {
      setUsersLoading(false);
    }
  };

  const fetchAllUsers = async () => {
    try {
      const response = await axios.get("tl-admin/user/list?page=-1");
      setAllUsers(response.data.result);
    } catch (err) {
      const error = getErrorMessage(err);
      showError(error, toast);
    }
  };

  const fetchRoles = async () => {
    try {
      const response = await axios.get("admin/role");
      setRoles(
        response.data.result.filter(
          (role: any) =>
            role.roleName !== ROLES.AMELIO_ADMIN &&
            role.roleName !== ROLES.MANAGEMENT
        )
      );
    } catch (err) {
      const error = getErrorMessage(err);
      showError(error, toast);
    }
  };

  // const fetchLineManagers = async () => {
  //   try {
  //     const response = await axios.get("tl-admin/line-manager/list");
  //     setLineManagersList(response.data.result);
  //   } catch (err) {
  //     const error = getErrorMessage(err);
  //     showError(error, toast);
  //   }
  // };

   const fetchAllTimeLogUsers = async () => {
    try {
      const response = await axios.get("tl-admin/timelog-users/list");
      setLineManagersList(response.data.result);
    } catch (err) {
      const error = getErrorMessage(err);
      showError(error, toast);
    }
  };

  const fetchDepartments = async () => {
    try {
      const response = await axios.get("tl-admin/department/all?page=-1");
      setDepartments(
        response.data.result.map((department: any) => ({
          department: department.name,
          managerID: department.managerID,
          departmentID: department.departmentID,
        }))
      );
    } catch (err) {
      const error = getErrorMessage(err);
      showError(error, toast);
    }
  };

  const fetchFilterLineManagers = async () => {
    try {
      const response = await axios.get("tl-admin/assigned-line-manager-list");
      setFilterLineManagers(response.data.result);
    } catch (err) {
      const error = getErrorMessage(err);
      showError(error, toast);
    }
  };

  useEffect(() => {
    if (formType === "add" || !timeLogRoleIDs) {
      if (
        formValues?.departments &&
        (formValues?.departments?.length > 0 || !selectedLineManager)
      ) {
        const lastDepartment =
          formValues.departments[formValues.departments.length - 1];

        const manager = lineManagersList.find(
          (manager: any) => manager.userID === lastDepartment.managerID
        );

        if (manager) {
          setSelectedLineManager(manager);
          setFormValues((prevFormValues) => ({
            ...prevFormValues,
            lineManagerID: manager.userID,
          }));
          setFormErrors((prevErrors) => ({
            ...prevErrors,
            lineManager: null,
          }));
        }
      } else if (
        formValues.departments &&
        formValues.departments.length === 0 &&
        selectedLineManager
      ) {
        setSelectedLineManager(null);
        setFormValues((prevFormValues) => ({
          ...prevFormValues,
          lineManagerID: null,
        }));
      }
    }
  }, [formValues?.departments, lineManagersList]);

  useEffect(() => {
    fetchRoles();
    fetchFilterLineManagers();
    fetchDepartments();
  }, []);

  useEffect(() => {
    setFirst(page);
    fetchAllTimeLogUsers();
    fetchUsers(page, size);
    fetchAllUsers();
  }, [
    selectedManagerFilter,
    filters?.departments,
    statusFilter,
    sortFilter,
    searchUserNameWithDebounce,
    selectedRoleFilter,
  ]);

  const shouldShowTimelogFields = () => {
    if (!selectedUserRole) return false;
    const rolesArray = Array.isArray(selectedUserRole)
      ? selectedUserRole
      : [selectedUserRole];
    return rolesArray.some((role: any) =>
      [ROLES.TIMELOG_ADMIN, ROLES.TIMELOG_EMPLOYEE, ROLES.TIMELOG_HR].includes(
        role?.roleName
      )
    );
  };

  const validateForm = () => {
    const errors: Partial<Record<string, string>> = {};

    if (!formValues.firstName || formValues.firstName.trim() === "") {
      errors.firstName = "FirstName is required";
    }
    if (!formValues.lastName || formValues.lastName.trim() === "") {
      errors.lastName = "LastName is required";
    }
    if (!formValues.DOB) {
      errors.DOB = "Date of Birth is required";
    }
    if (!formValues.DOJ) {
      errors.DOJ = "Date of Joining is required";
    } else if (formValues.DOB > formValues.DOJ) {
      errors.DOJ = "Date of Joining should be greater than Date of Birth";
      showError(
        "Date of Joining should be greater than Date of Birth",
        toast,
        "",
        6000
      );
    }
    if (!formValues.userEmail || formValues.userEmail?.trim().length === 0) {
      errors.userEmail = "Email is required";
    } else if (!/\S+@\S+\.\S{2,}/.test(formValues.userEmail)) {
      errors.userEmail = "Email is invalid";
    }
    if (
      formValues?.roleID === null ||
      formValues?.roleID === undefined ||
      formValues?.roleID.length === 0
    )
      errors.roleID = "Role is required";
    // Only validate departments, leaves, and lineManager if selectedUserRole contains a timelog role
    const timelogRoles = [
      ROLES.TIMELOG_ADMIN,
      ROLES.TIMELOG_EMPLOYEE,
      ROLES.TIMELOG_HR,
    ];
    const selectedRoleNames = (selectedUserRole ?? []).map(
      (role: any) => role.roleName
    );
    const hasTimelogRole = selectedRoleNames.some((roleName: string) =>
      timelogRoles.includes(roleName)
    );
    if (hasTimelogRole) {
      if (
        !formValues.departments ||
        formValues?.departments.length === 0 ||
        !formValues?.departments[0]?.departmentID
      ) {
        errors.departments = "Department is required";
      }
      if (!formValues.leaves) {
        errors.leaves = "Leaves are required";
      }
      if (
        formValues.leaves === null ||
        formValues.leaves === undefined ||
        !/^(\d+(\.5)?|0\.5)$/.test(formValues.leaves.toString())
      ) {
        errors.leaves =
          "Leaves must be in increments of 0.5 (e.g. 0.5, 1, 1.5, 2, ...)";
        showError(
          "Leaves must be in increments of 0.5 (e.g. 0.5, 1, 1.5, 2, ...)",
          toast,
          "",
          8000
        );
      }
      if (!formValues.lineManagerID) {
        errors.lineManager = "Line Manager is required";
      }
    }
    setFormErrors((prev) => ({ ...prev, ...errors }));

    return Object.keys(errors).length === 0; // Returns true if no errors
  };

  const validateExtendTimeSheetForm = () => {
    const errors: Partial<Record<string, string>> = {};

    if (!extendTimeSheetData.name) {
      errors.name = "Name is required";
    }
    if (!extendTimeSheetData.startDate) {
      errors.startDate = "Start date is required";
    }
    if (!extendTimeSheetData.endDate) {
      errors.endDate = "End date is required";
    }
    if (!extendTimeSheetData.extendHours) {
      errors.extendHours = "Extend hours is required";
    }
    setExtendTimeSheetFormErrors((prev: any) => ({ ...prev, ...errors }));

    return Object.keys(errors).length === 0; // Returns true if no errors
  };

  const handleCheckTimelogOrLeaveAdded = async (userID: any, isActive: any) => {
    let checkInvoiceDuplicateStatus = null;

    if (isActive === 0) {
      checkInvoiceDuplicateStatus = await checkTimelogOrLeaveAdded(userID);
    }

    if (checkInvoiceDuplicateStatus && checkInvoiceDuplicateStatus === 409) {
      confirmToProceed(async () => {
        handleStatusChangeClick(userID, isActive === 0 ? 1 : 0);
      });
      return;
    }
    handleStatusChangeClick(userID, isActive === 0 ? 1 : 0);
  };

  const handleCheckRoleChanged = async (formType?: string) => {
    let checkTimelogRoleChangedStatus = null;

    if (!validateForm()) return; // Stop submission if validation fails
    // For "add" (create user), call handleAddUpdateUser directly
    if (formType === "add") {
      await handleAddUpdateUser(formType);
      return;
    }
    checkTimelogRoleChangedStatus = await checkRoleChanged(
      formValues?.userID,
      formValues?.roleID
    );

    if (
      checkTimelogRoleChangedStatus &&
      checkTimelogRoleChangedStatus === 409
    ) {
      confirmUpdateUser(async () => {
        await handleAddUpdateUser(formType);
      });
      return;
    }
    await handleAddUpdateUser(formType);
  };

  const handleAddUpdateUser = async (formType?: string) => {
    if (!validateForm()) return; // Stop submission if validation fails

    try {
      const userData: any = {};

      // Only check if selectedUserRole consists of timelog roles
      const timelogRoles = [
        ROLES.TIMELOG_ADMIN,
        ROLES.TIMELOG_EMPLOYEE,
        ROLES.TIMELOG_HR,
      ];
      const selectedRoleNames = (selectedUserRole ?? []).map(
        (role: any) => role.roleName
      );
      const hasTimelogRole = selectedRoleNames.some((roleName: string) =>
        timelogRoles.includes(roleName)
      );
      if (
        hasTimelogRole &&
        formValues?.userID?.toString() === formValues?.lineManagerID?.toString()
      ) {
        showError("User cannot be his/her own line manager", toast);
        return;
      }
      setIsAddButtonDisabled(true);
      if (formType === "update") {
        userData.userID = formValues?.userID;
      }
      userData.firstName = formValues?.firstName?.trim();
      userData.lastName = formValues?.lastName?.trim();
      userData.DOB = formValues?.DOB;
      userData.DOJ = formValues?.DOJ;
      userData.userEmail = formValues?.userEmail?.trim();

      if (hasTimelogRole) {
        userData.departments = formValues?.departments?.map(
          (departments: any) => departments.departmentID
        );
        userData.leaves = formValues?.leaves;
        userData.lineManagerID = formValues?.lineManagerID;
      }

      userData.roleID =
        typeof formValues?.roleID === "string"
          ? formValues?.roleID.split(",").map(Number)
          : formValues?.roleID;

      formType === "add"
        ? await axios.post("admin/create-user", userData)
        : await axios.post("admin/user/update", userData);
      setIsDialogVisible(false);
      setSelectedUserRole(null);
      setFormValues({
        firstName: null,
        lastName: null,
        DOB: null,
        DOJ: null,
        userEmail: null,
        departments: null,
        roleID: null,
        leaves: null,
        lineManagerID: null,
        isActive: formType === "add" ? 1 : formValues.isActive,
      });
      setFormErrors({
        firstName: null,
        lastName: null,
        DOB: null,
        DOJ: null,
        userEmail: null,
        departments: null,
        roleID: null,
        leaves: null,
        lineManager: null,
      });
      setSelectedDOB(null);
      setSelectedDOJ(null);
      setSelectedLineManager(null); // Reset the selected manager
      setFirst(page);
      fetchAllTimeLogUsers();
      fetchFilterLineManagers();
      fetchUsers(page, size);
      fetchAllUsers();
      setIsAddButtonDisabled(false);
    } catch (err) {
      const error = getErrorMessage(err);
      showError(error, toast);
      setIsAddButtonDisabled(false);
    }
  };

  const handleEditUser = (rowData: any) => {
    setFormType("update");

    const manager = lineManagersList.find(
      (user: any) => user.userID === rowData.lineManagerID
    );
    const invoiceRoleValues = Object.values(INVOICE_ROLES);
    const roleDisplayNames =
      rowData?.roleDisplayName?.split(",").map((r: string) => r.trim()) ?? [];

    const remainingRoleIDs =
      roleDisplayNames &&
      roleDisplayNames
        .filter((role: any) => !invoiceRoleValues.includes(role.trim()))
        .map((roleDisplayName: string) => {
          const matchedRole = roles.find(
            (role) => role.roleDisplayName === roleDisplayName.trim()
          );
          return matchedRole ? matchedRole.roleID : null;
        })
        .filter((roleID: any) => roleID !== null);

    setTimeLogRoleIDs(
      (remainingRoleIDs ?? []).length === 0 ? null : remainingRoleIDs ?? []
    );
    const selectedRoles = roles.filter((role) =>
      roleDisplayNames.includes(role.roleDisplayName)
    );
    setSelectedDOB(getOriginalDate(rowData.DOB) || null);
    setSelectedDOJ(getOriginalDate(rowData.DOJ) || null);

    // Set the selected manager
    setSelectedLineManager(manager || null);
    setSelectedUserRole(selectedRoles || null);
    setFormValues({
      userID: rowData.userID,
      firstName: rowData.firstName,
      lastName: rowData.lastName,
      DOB: rowData.DOB,
      DOJ: rowData.DOJ,
      userEmail: rowData?.userEmail,
      departments: rowData.departments?.map((department: any) => ({
        department: department?.department,
        managerID: department?.managerID,
        departmentID: department?.departmentID,
      })),
      roleID: rowData.roleID,
      roleDisplayName: rowData?.roleDisplayName,
      leaves: rowData?.total_leaves,
      lineManagerID: rowData?.lineManagerID,
      isActive: rowData?.isActive,
    });
    setIsDialogVisible(true);
  };

  const updateUserstatus = async (
    userID: any,
    isActive: number,
    reason: string
  ) => {
    try {
      setIsAddButtonDisabled(true);
      setFormValues((prevFormValues) => ({
        ...prevFormValues,
        userID,
      }));
      const statusResponse = await axios.post("admin/user/update", {
        userID,
        isActive: isActive === 1 ? true : false,
        statusChangeReason: reason,
      });
      if (statusResponse.status === 200) {
        showSuccess(statusResponse.data.Message, toast);
        const updatedUsers = users.map((user) =>
          user.userID === userID ? { ...user, isActive: isActive } : user
        );
        setUsers(updatedUsers);
      } else {
        setIsAddButtonDisabled(false);
      }
      setIsAddButtonDisabled(false);
      // Reset status change states
      setIsStatusDialogVisible(false);
      setStatusChangeReason("");
      setPendingStatusChange(null);
    } catch (err) {
      const error = getErrorMessage(err);
      showError(error, toast);
      setIsAddButtonDisabled(false);
      setIsStatusDialogVisible(false);
      setStatusChangeReason("");
      setPendingStatusChange(null);
    }
  };

  const handleStatusChangeClick = (userID: string, currentStatus: number) => {
    setPendingStatusChange({
      userID,
      isActive: currentStatus === 1 ? 0 : 1,
    });
    setStatusChangeReason("");
    setIsStatusDialogVisible(true);
  };

  const confirmStatusChange = () => {
    if (!statusChangeReason.trim()) {
      setStatusChangeReasonError(
        "Please provide a reason for the status change"
      );
      return;
    }
    setStatusChangeReasonError(null);
    if (pendingStatusChange) {
      updateUserstatus(
        pendingStatusChange.userID,
        pendingStatusChange.isActive,
        statusChangeReason
      ).then(() => {
        fetchUsers(page, size);
        setIsStatusDialogVisible(false);
      });
    }
  };

  const formatCreatedDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = date.getUTCDate().toString().padStart(2, "0");
    const month = date.toLocaleString("en-UK", { month: "short" });
    const year = date.getUTCFullYear();
    const hours = date.getUTCHours().toString().padStart(2, "0");
    const minutes = date.getUTCMinutes().toString().padStart(2, "0");
    return `${day} ${month} ${year}, ${hours}:${minutes}`;
  };

  const events: any = userStatusChangeActivity?.map((activity: any) => ({
    actionTakerID: activity?.actionTakerID,
    date: activity?.createdDate,
    actionTakerDisplayName: activity?.actionTakerName,
    comment: activity?.statusChangeReason,
    action:
      activity?.previousStatus && activity?.newStatus
        ? `Status changed from ${
            activity.previousStatus.charAt(0).toUpperCase() +
            activity.previousStatus.slice(1).toLowerCase()
          } to ${
            activity.newStatus.charAt(0).toUpperCase() +
            activity.newStatus.slice(1).toLowerCase()
          }`
        : null,
    id: activity?.id,
    previousStatus: activity?.previousStatus,
    newStatus: activity?.newStatus,
  }));

  const customizedMarker = () => (
    <div className="tw-flex tw-justify-center tw-items-center tw-w-5 tw-h-5 tw-rounded-full tw-bg-[#E2E8F0]">
      <div className="tw-w-3 tw-h-3 tw-rounded-full tw-bg-[#00AFEE]"></div>
    </div>
  );

  const customizedContent = (item: any) =>
    item?.action ? (
      <Card className="activity-card tw-bg-gray-50">
        <div className="activity-container tw-flex tw-justify-between tw-items-center tw-mb-4">
          <span className="activity-date tw-text-ellipsis tw-overflow-hidden tw-max-w-52">
            {formatCreatedDate(item?.date)}
          </span>
        </div>
        <span className="activity-content tw-text-ellipsis tw-overflow-hidden tw-max-w-52">
          <span>
            <span className="tw-font-medium tw-text-gray-700">
              {item?.action}
            </span>{" "}
            <span className="tw-text-gray-600">
              by {item?.actionTakerDisplayName}
            </span>
          </span>
        </span>
        <div className="tw-flex tw-justify-between tw-items-center tw-mt-1 tw-font-medium tw-text-[#6611119c]">
          <span className="tw-ml-auto">{item?.comment}</span>
        </div>
      </Card>
    ) : (
      <div>No History Found</div>
    );

  const onPageChange = (event: PaginatorPageChangeEvent) => {
    setFirst(event.first);
    setSize(event.rows); // Set the number of rows per page
    const currentPage = Math.floor(event.first / event.rows); // Calculate the current page index
    fetchUsers(currentPage, event.rows);
  };

  const validDateRoles = (selectedRoles: any) => {
    const roleNames = selectedRoles.map((role: any) => role.roleName);

    // Check for Super Admin + Accountant
    if (
      roleNames.includes(ROLES.SUPER_ADMIN) &&
      roleNames.includes(ROLES.ACCOUNTANT)
    ) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        roleID: "Super Admin and Accountant cannot be selected together.",
      }));
      return false;
    }

    // Check for Manager + Accountant
    if (
      roleNames.includes(ROLES.MANAGER) &&
      roleNames.includes(ROLES.ACCOUNTANT)
    ) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        roleID: "Manager and Accountant cannot be selected together.",
      }));
      return false;
    }

    // Check for Senior Manager + Accountant
    if (
      roleNames.includes(ROLES.SENIOR_MANAGER) &&
      roleNames.includes(ROLES.ACCOUNTANT)
    ) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        roleID: "Senior Manager and Accountant cannot be selected together.",
      }));
      return false;
    }

    // Check for Accountant + Director
    if (
      roleNames.includes(ROLES.ACCOUNTANT) &&
      roleNames.includes(ROLES.DIRECTOR)
    ) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        roleID: "Accountant and Director cannot be selected together.",
      }));
      return false;
    }

    // Check for Manager + Director
    if (
      roleNames.includes(ROLES.MANAGER) &&
      roleNames.includes(ROLES.DIRECTOR)
    ) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        roleID: "Manager and Director cannot be selected together.",
      }));
      return false;
    }

    // Check for Senior Manager + Director
    if (
      roleNames.includes(ROLES.SENIOR_MANAGER) &&
      roleNames.includes(ROLES.DIRECTOR)
    ) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        roleID: "Senior Manager and Director cannot be selected together.",
      }));
      return false;
    }

    // Check for Senior Manager + Manager
    if (
      roleNames.includes(ROLES.SENIOR_MANAGER) &&
      roleNames.includes(ROLES.MANAGER)
    ) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        roleID: "Senior Manager and Manager cannot be selected together.",
      }));
      return false;
    }

    // Check for Timelog Admin + Timelog Employee
    if (
      roleNames.includes(ROLES.TIMELOG_ADMIN) &&
      roleNames.includes(ROLES.TIMELOG_EMPLOYEE)
    ) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        roleID:
          "Timelog Admin and Timelog Employee cannot be selected together.",
      }));
      return false;
    }

    // Check for Timelog Admin + Timelog HR
    if (
      roleNames.includes(ROLES.TIMELOG_ADMIN) &&
      roleNames.includes(ROLES.TIMELOG_HR)
    ) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        roleID: "Timelog Admin and Timelog HR cannot be selected together.",
      }));
      return false;
    }

    // Check for Timelog HR + Timelog Employee
    if (
      roleNames.includes(ROLES.TIMELOG_HR) &&
      roleNames.includes(ROLES.TIMELOG_EMPLOYEE)
    ) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        roleID: "Timelog HR and Timelog Employee cannot be selected together.",
      }));
      return false;
    }

    // Check for Hands Admin + Hands User
    if (
      roleNames.includes(ROLES.HANDS_ADMIN) &&
      roleNames.includes(ROLES.HANDS_USER)
    ) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        roleID: "Hands Admin and Hands User cannot be selected together.",
      }));
      return false;
    }

    return true;
  };

  const handleRoleChange = (e: any, type?: string) => {
    const selectedRoles = e.value;
    if (!validDateRoles(selectedRoles)) {
      return; // If roles are invalid, do not proceed
    }
    setSelectedUserRole(selectedRoles);
    setFormValues((prevFormValues: any) => ({
      ...prevFormValues,
      roleID: selectedRoles.map((role: any) => role.roleID),
    }));
    setFormErrors((prevFormErrors: FormErrors) => ({
      ...prevFormErrors,
      roleID: null,
    }));
  };

  const checkTimelogOrLeaveAdded = async (userID: any) => {
    try {
      setIsAddButtonDisabled(true);
      const response = await axios.get(
        `admin/check-timelog-leave-exist?userID=${userID}`
      );
      setIsAddButtonDisabled(false);
      return response.data.StatusCode;
    } catch (error: any) {
      setIsAddButtonDisabled(false);
      return error.status;
    }
  };

  const checkRoleChanged = async (userID: any, roleID: string) => {
    try {
      setIsAddButtonDisabled(true);

      const response = await axios.get(
        `admin/edit-user-check-role?userID=${userID}&roleID=${roleID}`
      );
      setIsAddButtonDisabled(false);
      return response.data.StatusCode;
    } catch (error: any) {
      setIsAddButtonDisabled(false);
      return error.status;
    }
  };

  const confirmToProceed = (onAccept: () => void) => {
    confirmDialog({
      message: "Are you sure you want to continue?",
      header: `User already has timelog or leave added, do you want to proceed?`,
      icon: "pi pi-exclamation-triangle",
      defaultFocus: "accept",
      accept: onAccept, // Call the provided callback on "Yes"
      reject: () => {},
      acceptClassName:
        "tw-bg-primary tw-text-white focus:tw-shadow-none tw-rounded-lg tw-px-4 tw-py-2 tw-font-medium tw-transition-all tw-duration-200", // Tailwind for "Yes"
      rejectClassName:
        "tw-rounded-lg tw-px-4 focus:tw-shadow-none tw-py-2 tw-font-medium tw-transition-all tw-duration-200 ", // Tailwind for "No"
    });
  };

  const confirmUpdateUser = (onAccept: () => void) => {
    confirmDialog({
      message: "Are you sure you want to continue?",
      header: `User has either timelog or leave added or both, do you still want to remove timelog role?`,
      icon: "pi pi-exclamation-triangle",
      defaultFocus: "accept",
      accept: onAccept, // Call the provided callback on "Yes"
      reject: () => {},
      acceptClassName:
        "tw-bg-primary tw-text-white focus:tw-shadow-none tw-rounded-lg tw-px-4 tw-py-2 tw-font-medium tw-transition-all tw-duration-200", // Tailwind for "Yes"
      rejectClassName:
        "tw-rounded-lg tw-px-4 focus:tw-shadow-none tw-py-2 tw-font-medium tw-transition-all tw-duration-200 ", // Tailwind for "No"
    });
  };

  const headerTemplate = (header: string, field: string) => {
    return (
      <div
        className={`tw-flex tw-justify-between tw-w-full tw-items-center ${
          field !== "" && "tw-cursor-pointer"
        }`}
        onClick={() => {
          if (field !== "") {
            setSortFilter((prevSortFilter: any) => ({
              ...prevSortFilter,
              sortField: field,
              sortOrder: !prevSortFilter.sortOrder,
            }));
          }
        }}
      >
        <span className="tw-font-bold">{header}</span>
        {field !== "" && (
          <span className="tw-ml-4 tw-mr-0">
            <TableSortingSVG />
          </span>
        )}
      </div>
    );
  };

  const departmentTemplate = (rowData: TimeLogUser) => {
    // If departments is not an array or empty or first departmentID is null, show "-"
    if (
      !Array.isArray(rowData?.departments) ||
      rowData?.departments.length === 0 ||
      !rowData?.departments[0]?.departmentID
    ) {
      return <span>-</span>;
    }
    return (
      <div className="tw-flex tw-flex-wrap">
        {rowData.departments.map((departments: any, index: number) => {
          return (
            <span key={index} className={index % 3 !== 2 ? "tw-mr-0" : ""}>
              {departments?.department}
              {index !== rowData?.departments?.length - 1 ? `,` : ""}&nbsp;
            </span>
          );
        })}
      </div>
    );
  };

  const roleBodyTemplate = (rowData: any) => {
    const statusClass = rowData.isActive ? "dot bg-success" : "dot bg-error";
    return (
      <span className="a-badge">
        <span className={statusClass}></span>
        <span className="badge-value">{rowData?.roleDisplayName ?? "N/A"}</span>
      </span>
    );
  };

  const getOriginalDate = (date: string | null): Date | null => {
    if (!date) return null;
    const formattedDate = convertEpochtoDate(date, "getDateValue");
    // Always create date in UTC
    const [year, month, day] = formattedDate.split("-").map(Number);
    // month - 1 because JS months are 0-based
    return new Date(Date.UTC(year, month - 1, day));
  };

  const handleExtendTimeSheetClick = (rowData: any) => {
    setShowExtendedTimesheet(true);
    setExtendTimeSheetData((prev: any) => ({
      ...prev,
      name: `${rowData.firstName} ${rowData.lastName}`,
      userID: rowData.userID,
    }));
  };

  const handleTimesheetLockClick = (rowData: any) => {
    setShowTimesheetLockDialog(true);
    setSelectedTimesheetLockDates([]);
    setTimesheetLockData({
      name: `${rowData.firstName} ${rowData.lastName}`,
      userID: rowData.userID,
      startDate: null,
      endDate: null,
    });
    setTimesheetLockFormErrors({
      name: null,
      startDate: null,
      endDate: null,
    });
    setTimesheetLockAction("unlock"); // Default to unlock
  };

  const validateTimesheetLockForm = () => {
    const errors: any = {};
    if (!timesheetLockData.startDate) {
      errors.startDate = "Start date is required";
    }
    if (!timesheetLockData.endDate) {
      errors.endDate = "End date is required";
    }
    setTimesheetLockFormErrors((prev: any) => ({ ...prev, ...errors }));
    return Object.keys(errors).length === 0;
  };

  const handleTimesheetLockDateChange = (date: any) => {
    if (!date) {
      setSelectedTimesheetLockDates([]);
      return;
    }

    // Calculate the week range: Monday to Sunday
    const selectedDate = new Date(date);
    const dayOfWeek = selectedDate.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday

    // Calculate Monday (start of week)
    const monday = new Date(selectedDate);
    const daysFromMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // If Sunday, go back 6 days; else go back (dayOfWeek - 1)
    monday.setDate(selectedDate.getDate() - daysFromMonday);

    // Calculate Sunday (end of week)
    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);

    // Set the dates in the calendar
    setSelectedTimesheetLockDates([monday, sunday]);

    // Convert to UTC before getting time
    const toUTC = (d: Date | null) =>
      d
        ? new Date(
            Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0)
          )
        : null;
    const formattedStartDate = Math.floor(toUTC(monday)!.getTime() / 1000.0);
    const formattedEndDate = Math.floor(toUTC(sunday)!.getTime() / 1000.0);

    setTimesheetLockData((prevFormValues: any) => ({
      ...prevFormValues,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    }));
    setTimesheetLockFormErrors((prevFormErrors: any) => ({
      ...prevFormErrors,
      startDate: null,
      endDate: null,
    }));
  };

  const handleTimesheetLockSubmit = async () => {
    if (!validateTimesheetLockForm()) return;

    setTimesheetLockLoading(true);
    try {
      const endpoint =
        timesheetLockAction === "lock"
          ? "tl-user/lock-timesheet"
          : "tl-user/unlock-timesheet";

      await axios.post(endpoint, {
        userID: timesheetLockData?.userID,
        startDate: timesheetLockData?.startDate,
        endDate: timesheetLockData?.endDate,
      });

      const successMessage =
        timesheetLockAction === "lock"
          ? "Timesheet locked successfully"
          : "Timesheet unlocked successfully";

      showSuccess(successMessage, toast);
      setShowTimesheetLockDialog(false);
      setSelectedTimesheetLockDates([]);
      setTimesheetLockData({
        name: null,
        userID: null,
        startDate: null,
        endDate: null,
      });
    } catch (error: any) {
      showError(getErrorMessage(error), toast);
    } finally {
      setTimesheetLockLoading(false);
    }
  };

  const actionBodyTemplate = (rowData: any) => {
    return (
      <div className="tw-flex tw-gap-4">
        <Button
          className="p-button-rounded tw-p-0 tw-w-auto tw-h-auto focus:tw-shadow-none"
          onClick={() => handleEditUser(rowData)}
        >
          <EditButtonSVG />
        </Button>
        <InputSwitch
          checked={rowData.isActive === 1}
          onChange={(e: InputSwitchChangeEvent) => {
            handleCheckTimelogOrLeaveAdded(rowData.userID, e.value ? 1 : 0);
          }}
          disabled={isAddButtonDisabled && rowData.userID === formValues.userID}
        />
        {rowData.roleDisplayName &&
          (rowData.roleDisplayName.includes(ROLES.TIMELOG_ADMIN) ||
            rowData.roleDisplayName.includes(ROLES.TIMELOG_EMPLOYEE) ||
            rowData.roleDisplayName.includes(ROLES.TIMELOG_HR)) && (
            <>
              <Button
                type="button"
                tooltip="Extend Timesheet"
                tooltipOptions={{
                  position: "left",
                }}
                className="tw-text-[#00AFEE] tw-font-bold tw-text-sm focus:tw-shadow-none"
                onClick={() => handleExtendTimeSheetClick(rowData)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM13 12H17V14H11V7H13V12Z"
                    fill="#00AFEE"
                  />
                </svg>
              </Button>
              <Button
                type="button"
                tooltip="Lock/Unlock Timesheet"
                tooltipOptions={{
                  position: "left",
                }}
                className="tw-text-[#00AFEE] tw-font-bold tw-text-sm focus:tw-shadow-none"
                onClick={() => handleTimesheetLockClick(rowData)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  // fill="none"
                >
                  <path
                    d="M17,9H9V7a3,3,0,0,1,5.12-2.13,3.08,3.08,0,0,1,.78,1.38,1,1,0,1,0,1.94-.5,5.09,5.09,0,0,0-1.31-2.29A5,5,0,0,0,7,7V9a3,3,0,0,0-3,3v7a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V12A3,3,0,0,0,17,9Zm1,10a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1H17a1,1,0,0,1,1,1Z"
                    fill="#00AFEE"
                  />
                </svg>
              </Button>
            </>
          )}
        <Button
          className="p-button-rounded tw-p-0 tw-w-auto tw-h-auto focus:tw-shadow-none"
          onClick={() => {
            setUserStatusChangeActivity(rowData?.userStatusChangeHistory || []);
            setSelectedRowData(rowData);
            setViewHistoryPopup(true);
          }}
          tooltip="View Status History"
          tooltipOptions={{ position: "top" }}
        >
          <i className="pi pi-info-circle tw-text-[#00AFEE] tw-text-xl"></i>
        </Button>
        {rowData.tempPass === 1 && rowData.roleID ? ( // Second condition for tempPass and roleId
          <>
            <Button
              className="tw-flex tw-px-3 tw-py-2 tw-rounded tw-bg-red-400 tw-border-red-400 tw-text-white tw-font-medium tw-text-sm"
              label="Reset Password"
              onClick={() => handleResetPassword(rowData)}
              disabled={resetPwdLoading && resetUserId === rowData.userID}
            />
            {resetPwdLoading && resetUserId === rowData.userID && (
              <CustomSpinner spinnerColour="tw-absolute tw-ml-[250px] tw-border-t-[#182c44]" />
            )}
          </>
        ) : null}
      </div>
    );
  };

  const userColumns: ColumnOption[] = [
    {
      field: "firstName",
      header: headerTemplate("First Name", "firstName"),
      body: (rowData: TimeLogUser) => rowData?.firstName || "-",
      visible: true,
    },
    {
      field: "lastName",
      header: headerTemplate("Last Name", "lastName"),
      body: (rowData: TimeLogUser) => rowData?.lastName || "-",
      visible: true,
    },
    {
      field: "userEmail",
      header: headerTemplate("Email", "userEmail"),
      body: (rowData: TimeLogUser) => rowData?.userEmail || "-",
      visible: true,
    },
    {
      field: "total_leaves",
      header: headerTemplate("Leaves", "total_leaves"),
      body: (rowData: any) => rowData?.total_leaves || "-",
      visible: true,
    },
    {
      field: "lineManager",
      header: headerTemplate("Line Manager", "lineManager"),
      body: (rowData: any) => rowData?.lineManager || "-",
      visible: true,
    },
    {
      field: "departments",
      header: headerTemplate("Department", ""),
      body: departmentTemplate,
      visible: true,
    },
    {
      field: "roleDisplayName",
      header: headerTemplate("Role", "roleDisplayName"),
      body: roleBodyTemplate,
      visible: true,
    },
    {
      field: "action",
      header: headerTemplate("Action", ""),
      body: actionBodyTemplate,
      visible: true,
    },
  ];

  const clearFilters = () => {
    setStatusFilter("all");
    setSelectedUserName(null);
    setSelectedManagerFilter(null);
    setSelectedUserRole(null);
    setSelectedRoleFilter(null);
    setFilters((prevFilters) => ({
      ...prevFilters,
      displayName: null,
      manager: null,
      departments: null,
      status: "all",
    }));
  };

  const items = [
    {
      items: [
        {
          template: (
            <div className="tw-flex tw-flex-col tw-gap-2 tw-mx-5 tw-w-62 tw-mt-3 tw-mb-5">
              <label htmlFor="userName">Name</label>
              <div className="tw-relative tw-w-full">
                <AutoComplete
                  className={`"tw-border-gray-300" tw-px-[12px] tw-pr-[10px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
                  value={selectedUserName}
                  suggestions={userNamesuggestions}
                  completeMethod={(e) => {
                    const query = e.query.toLowerCase();
                    const filtered = allUsers.filter((user: any) =>
                      user.displayName.toLowerCase().includes(query)
                    );
                    if (filtered.length === 0) {
                      setUserNameSuggestions([
                        {
                          displayName: "No records found",
                          projectID: null,
                          disabled: true,
                        },
                      ]);
                    } else {
                      setUserNameSuggestions(filtered);
                    }
                  }}
                  field="displayName"
                  placeholder="Search User Name"
                  onChange={(e) => {
                    // Check if e.value is a string (manual typing) or an object (selection from dropdown)
                    if (typeof e.value === "string") {
                      setSelectedUserName(e.value);
                      setFilters((prevFilters) => ({
                        ...prevFilters,
                        displayName: e.value || null,
                      }));
                    } else {
                      setSelectedUserName(e.value);
                      setFilters((prevFilters) => ({
                        ...prevFilters,
                        displayName: e.value?.displayName || null,
                      }));
                    }
                  }}
                  onClick={(e) => e.stopPropagation()}
                  // Explicitly handle input events
                  inputRef={(el) => {
                    if (el) {
                      el.addEventListener("keydown", (e) => {
                        // Prevent any default handling of space that might be causing issues
                        if (e.key === " " || e.code === "Space") {
                          e.stopPropagation();
                        }
                      });
                    }
                  }}
                  // Make sure the component doesn't filter out spaces
                  forceSelection={false}
                  panelClassName="tw-w-full tw-mt-[11px]"
                  appendTo="self"
                />
              </div>
            </div>
          ),
        },
        {
          template: (
            <div className="tw-flex tw-flex-col tw-gap-2 tw-mx-5 tw-w-62 tw-mt-3 tw-mb-5">
              <label htmlFor="Manager">Line Manager</label>
              <Dropdown
                className="tw-h-11 tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-w-full placeholder:tw-font-normal filter-dropdown"
                value={selectedManagerFilter}
                options={filterLineManagers}
                optionLabel="displayName" // Assuming 'roles' contains an array of objects with a 'role' key
                placeholder="Select line manager"
                onChange={(e) => {
                  setSelectedManagerFilter(e.target.value);
                  setFilters((prevFilters) => ({
                    ...prevFilters,
                    manager: e.target.value,
                  }));
                }}
                filter
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          ),
        },
        {
          template: (
            <div className="tw-flex tw-flex-col tw-gap-2 tw-mx-5 tw-w-62 tw-mt-3 tw-mb-5">
              <label htmlFor="manager">Department</label>
              <Dropdown
                className="tw-h-11 tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-w-full placeholder:tw-font-normal filter-dropdown"
                value={filters?.departments ?? null}
                options={departments}
                optionLabel="department" // Assuming 'roles' contains an array of objects with a 'role' key
                placeholder="Select departments"
                onChange={(e) => {
                  setFilters((prevFilters) => ({
                    ...prevFilters,
                    departments: e.target.value,
                  }));
                }}
                filter
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          ),
        },
        {
          template: (
            <div className="tw-flex tw-flex-col tw-gap-2 tw-mx-5 tw-w-62 tw-mt-3 tw-mb-5">
              <label htmlFor="UploadedOn">Role</label>
              <MultiSelect
                className="tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-w-full placeholder:tw-font-normal"
                value={selectedRoleFilter || []}
                selectAllLabel="Select All"
                options={roles}
                onChange={(e) => setSelectedRoleFilter(e.value)}
                maxSelectedLabels={1}
                onKeyDown={handleKeyDown} // Add the key down handler here
                optionLabel="roleDisplayName" // Assuming 'roles' contains an array of objects with a 'role' key
                placeholder="Select Role"
                onClick={(e) => e.stopPropagation()}
                showClear
              />
            </div>
          ),
        },
        {
          template: (
            <div className="tw-flex tw-flex-wrap tw-gap-3 tw-items-center tw-mx-7 tw-w-62 tw-mt-5 tw-mb-3">
              {STATUS_FILTER.map((status) => (
                <div key={status.id} className="tw-flex tw-items-center">
                  <RadioButton
                    key={status.id}
                    inputId={status.id}
                    value={status.value}
                    checked={statusFilter === status.value}
                    onChange={(e) =>
                      setStatusFilter(e.value as "all" | "active" | "inactive")
                    }
                  />
                  <label htmlFor={status.id} className="tw-ml-1">
                    {status.label}
                  </label>
                </div>
              ))}
            </div>
          ),
        },
        {
          template: (
            <div className="tw-flex tw-flex-col tw-gap-2 tw-mx-5 tw-w-62 tw-mt-3 tw-mb-4">
              <Button
                className="tw-flex tw-px-3 tw-py-2 tw-rounded tw-bg-red-500 hover:tw-bg-red-500 tw-font-medium tw-gap-2 tw-text-white"
                onClick={clearFilters} // This function will reset filters
              >
                Clear Filters
              </Button>
            </div>
          ),
        },
      ],
    },
  ];

  return (
    <>
      <Toast ref={toast} />
      <ConfirmDialog />
      <div className="card">
        <div className="tw-flex tw-justify-between tw-items-center tw-w-full tw-gap-4 tw-bg-[#F8FAFC] tw-p-4 tw-mr-4">
          <h1 className="tw-font-bold tw-text-xl">User Management</h1>

          <div className="tw-flex tw-gap-2 focus:tw-shadow-none">
            <FilterButton menu={menu} />

            <Menu
              className="tw-w-72"
              model={items as MenuItem[]}
              popup
              ref={menu}
            />

            <Button
              className="tw-flex tw-px-3 tw-py-2 tw-rounded bg-primary hover:tw-bg-[#02a2db] border-primary tw-text-white tw-font-medium"
              label="Add User"
              icon="pi pi-plus"
              onClick={() => {
                setFormType("add");
                setFormValues({
                  firstName: null,
                  lastName: null,
                  DOB: null,
                  DOJ: null,
                  userEmail: null,
                  departments: null,
                  roleID: null,
                  leaves: null,
                  lineManagerID: null,
                  isActive: 1,
                });
                setFormErrors({
                  firstName: null,
                  lastName: null,
                  DOB: null,
                  DOJ: null,
                  userEmail: null,
                  departments: null,
                  roleID: null,
                  leaves: null,
                  lineManager: null,
                });
                setSelectedDOB(null);
                setSelectedDOJ(null);
                setIsDialogVisible(true);
              }}
            />
            <Button
              type="button"
              icon="pi pi-upload"
              label="Export"
              loading={isExporting}
              className="tw-flex tw-px-9 tw-py-2 tw-rounded bg-secondary border-primary hover:tw-bg-[#3f3c3c] tw-text-white tw-font-medium focus:tw-shadow-none"
              onClick={() => fetchUsers(page, size, "export")}
            />
          </div>
        </div>
        <div className="card-body tw-relative tw-min-h-80 table-p-0">
          {usersLoading ? (
            <div className="tw-h-full tw-w-full tw-bg-white tw-flex tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-0 tw-z-50">
              <ProgressSpinner />
            </div>
          ) : (
            <>
              <DataTableComponent
                rowData={users}
                columns={userColumns}
                customClass="timelog-datatable"
              />

              <Paginator
                first={first}
                rows={size}
                totalRecords={totalRecords} // Set total records for pagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                onPageChange={onPageChange}
              />
            </>
          )}
        </div>
      </div>
      <Dialog
        header={formType === "add" ? "Add User" : "Update User"}
        visible={isDialogVisible}
        draggable={false}
        style={{ width: "24vw" }}
        onHide={() => {
          if (!isDialogVisible) return;
          setIsDialogVisible(false);
          setFormErrors({
            firstName: null,
            lastName: null,
            DOB: null,
            DOJ: null,
            userEmail: null,
            departments: null,
            roleID: null,
            leaves: null,
            lineManager: null,
          });
          setFormValues({
            firstName: null,
            lastName: null,
            DOB: null,
            DOJ: null,
            userEmail: null,
            departments: null,
            roleID: null,
            leaves: null,
            lineManagerID: null,
            isActive: 1,
          });
          setSelectedDOB(null);
          setSelectedDOJ(null);
          setSelectedLineManager(null); // Reset the selected manager
          setSelectedUserRole(null);
          setFormType("add");
        }}
      >
        <div className="tw-flex tw-flex-col">
          <div className="tw-mt-0 tw-flex tw-flex-col tw-gap-2">
            <label className="tw-font-bold">First Name</label>
            <InputText
              value={formValues?.firstName ?? ""}
              className={`${
                formErrors.firstName
                  ? "tw-border-red-600"
                  : "tw-border-gray-300"
              } tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
              onChange={(e) => {
                setFormErrors((prevErrors) => ({
                  ...prevErrors,
                  firstName: null,
                }));
                e.target.value === ""
                  ? setFormValues((prevFormValues) => ({
                      ...prevFormValues,
                      firstName: null,
                    }))
                  : setFormValues((prevFormValues) => ({
                      ...prevFormValues,
                      firstName: e.target.value,
                    }));
              }}
              placeholder="Enter First Name"
            />
          </div>
          <div className="tw-flex tw-flex-col tw-gap-2 tw-mt-4">
            <label className="tw-font-bold">Last Name</label>
            <InputText
              value={formValues?.lastName ?? ""}
              className={`${
                formErrors.lastName ? "tw-border-red-600" : "tw-border-gray-300"
              } tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
              onChange={(e) => {
                setFormErrors((prevErrors) => ({
                  ...prevErrors,
                  lastName: null,
                }));
                e.target.value === ""
                  ? setFormValues((prevFormValues) => ({
                      ...prevFormValues,
                      lastName: null,
                    }))
                  : setFormValues((prevFormValues) => ({
                      ...prevFormValues,
                      lastName: e.target.value,
                    }));
              }}
              placeholder="Enter Last Name"
            />
          </div>

          <div
            className="tw-mt-3 tw-flex tw-flex-col tw-gap-2"
            onClick={(e) => e.stopPropagation()} // Prevents the menu from closing
          >
            <label className="tw-font-bold">Date of Birth </label>
            <Calendar
              className={`${
                formErrors.DOB ? "tw-border-red-600" : "tw-border-gray-300"
              } tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
              dateFormat="dd-mm-yy"
              value={selectedDOB}
              maxDate={selectedDOJ ? selectedDOJ : undefined}
              placeholder="Select date of birth"
              onChange={(e) => {
                e.stopPropagation();
                setSelectedDOB(e.value);
                if (e.value) {
                  // Store UTC 12am in formValues
                  const utcDate = new Date(
                    Date.UTC(
                      e.value.getFullYear(),
                      e.value.getMonth(),
                      e.value.getDate(),
                      0,
                      0,
                      0,
                      0
                    )
                  );
                  setFormValues((prev) => ({
                    ...prev,
                    DOB: Math.floor(utcDate.getTime() / 1000),
                  }));
                  setFormErrors((prev) => ({ ...prev, DOB: null }));
                } else {
                  setFormValues((prev) => ({ ...prev, DOB: null }));
                }
              }}
              showIcon
              readOnlyInput={false} // Allow typing
              onInput={(e: any) => {
                const inputValue = e.target.value;
                const dateRegex = /^\d{2}-\d{2}-\d{4}$/; // Regex for dd-mm-yyyy format
                if (dateRegex.test(inputValue)) {
                  const [day, month, year] = inputValue.split("-").map(Number);
                  const typedDate = new Date(year, month - 1, day);
                  if (!isNaN(typedDate.getTime())) {
                    // InvoiceDateConst(typedDate, "startDate");
                    setSelectedDOB(typedDate);
                    if (typedDate) {
                      // Store UTC 12am in formValues
                      const utcDate = new Date(
                        Date.UTC(
                          typedDate.getFullYear(),
                          typedDate.getMonth(),
                          typedDate.getDate(),
                          0,
                          0,
                          0,
                          0
                        )
                      );
                      setFormValues((prev) => ({
                        ...prev,
                        DOB: Math.floor(utcDate.getTime() / 1000),
                      }));
                      setFormErrors((prev) => ({ ...prev, DOB: null }));
                    } else {
                      setFormValues((prev) => ({ ...prev, DOB: null }));
                    }
                  }
                }
              }}
              hideOnRangeSelection
            />
          </div>

          <div
            className="tw-mt-3 tw-flex tw-flex-col tw-gap-2"
            onClick={(e) => e.stopPropagation()} // Prevents the menu from closing
          >
            <label className="tw-font-bold">Date of Joining</label>
            <Calendar
              className={`${
                formErrors.DOJ ? "tw-border-red-600" : "tw-border-gray-300"
              } tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
              dateFormat="dd-mm-yy"
              value={selectedDOJ}
              placeholder="Select date of joining"
              onChange={(e) => {
                e.stopPropagation();
                setSelectedDOJ(e.value);
                if (e.value) {
                  // Store UTC 12am in formValues
                  const utcDate = new Date(
                    Date.UTC(
                      e.value.getFullYear(),
                      e.value.getMonth(),
                      e.value.getDate(),
                      0,
                      0,
                      0,
                      0
                    )
                  );
                  setFormValues((prev) => ({
                    ...prev,
                    DOJ: Math.floor(utcDate.getTime() / 1000),
                  }));
                  setFormErrors((prev) => ({ ...prev, DOJ: null }));
                } else {
                  setFormValues((prev) => ({ ...prev, DOJ: null }));
                }
              }}
              minDate={selectedDOB ? selectedDOB : undefined}
              showIcon
              readOnlyInput
              hideOnRangeSelection
            />
          </div>

          <div className="tw-flex tw-flex-col tw-gap-2 tw-mt-4">
            <label htmlFor="Email" className="tw-font-bold">
              Email
            </label>
            <InputText
              type="email"
              className={`${
                formErrors.userEmail
                  ? "tw-border-red-600"
                  : "tw-border-gray-300"
              } tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
              placeholder="Enter your email"
              id="Email"
              aria-describedby="fullname-help"
              value={formValues?.userEmail ?? ""}
              onChange={(e) => {
                setFormErrors((prevErrors) => ({
                  ...prevErrors,
                  userEmail: null,
                }));
                e.target.value === ""
                  ? setFormValues((prevFormValues) => ({
                      ...prevFormValues,
                      userEmail: null,
                    }))
                  : setFormValues((prevFormValues) => ({
                      ...prevFormValues,
                      userEmail: e.target.value,
                    }));
              }}
            />
            {/* {formErrors.userEmail && (
                      <p className="tw-text-red-600 tw-text-xs">{formErrors.userEmail}</p>
                    )} */}
          </div>

          <div className="tw-flex tw-flex-col tw-gap-2 tw-mt-4">
            <label htmlFor="Role" className="tw-font-bold">
              Role
            </label>
            <MultiSelect
              className={`tw-border tw-border-solid ${
                formErrors.roleID ? "tw-border-red-600" : "tw-border-gray-300"
              } tw-rounded-md placeholder:tw-font-normal tw-w-full`}
              value={selectedUserRole ?? []}
              id="Role"
              maxSelectedLabels={2}
              onChange={(e) => {
                handleRoleChange(e, formType);
              }}
              options={roles}
              filter
              optionLabel="roleDisplayName"
              placeholder="Select Role"
            />
            {formErrors.roleID && (
              <p className="tw-text-red-600 tw-text-xs">
                {formErrors.roleID === "Role is required"
                  ? ""
                  : formErrors.roleID}
              </p>
            )}
          </div>

          {shouldShowTimelogFields() && (
            <>
              <div className="tw-flex tw-flex-col tw-gap-2 tw-mt-4">
                <label htmlFor="Role" className="tw-font-bold">
                  Department
                </label>
                <MultiSelect
                  value={
                    formValues.departments &&
                    formValues?.departments[0]?.departmentID
                      ? formValues.departments
                      : []
                  }
                  id="departments"
                  selectAll={departments.length > 0}
                  selectAllLabel={`${
                    departments.length > 0 ? "Select All" : null
                  }`}
                  onChange={(e) => {
                    setFormErrors((prevErrors) => ({
                      ...prevErrors,
                      departments: null,
                    }));
                    setFormValues((prevFormValues) => ({
                      ...prevFormValues,
                      departments: e.value,
                    }));
                  }}
                  options={departments}
                  maxSelectedLabels={2}
                  optionLabel="department"
                  placeholder={
                    departments.length > 0
                      ? "Select departments(s)"
                      : "No departments available"
                  }
                  className={`tw-border tw-border-solid ${
                    formErrors.departments
                      ? "tw-border-red-600"
                      : "tw-border-gray-300"
                  } tw-rounded-md placeholder:tw-font-normal tw-w-full`}
                  disabled={departments.length === 0}
                />
              </div>
              <div className="tw-flex tw-flex-col tw-gap-2 tw-mt-4">
                <label className="tw-font-bold">Leaves</label>
                <InputNumber
                  value={formValues?.leaves ?? null}
                  className={`${
                    formErrors.leaves
                      ? "tw-border-red-600"
                      : "tw-border-gray-300"
                  } tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
                  onChange={(e) => {
                    setFormErrors((prevErrors) => ({
                      ...prevErrors,
                      leaves: null,
                    }));
                    setFormValues((prevFormValues) => ({
                      ...prevFormValues,
                      leaves: e.value,
                    }));
                  }}
                  onKeyDown={(evt) => {
                    if (
                      evt.key === "+" ||
                      evt.key === "-" ||
                      evt.key === "ArrowUp" ||
                      evt.key === "ArrowDown"
                    ) {
                      evt.preventDefault();
                    }
                  }}
                  useGrouping={false}
                  placeholder="Enter number of Leaves"
                />
              </div>
              <div className="tw-flex tw-flex-col tw-gap-2 tw-mt-4">
                <label htmlFor="lineManager" className="tw-font-bold">
                  Line Manager
                </label>
                <Dropdown
                  value={selectedLineManager}
                  id="lineManager"
                  onChange={(e) => {
                    setFormErrors((prevErrors) => ({
                      ...prevErrors,
                      lineManager: null,
                    }));
                    setSelectedLineManager(e.value);
                    setFormValues((prevFormValues) => ({
                      ...prevFormValues,
                      lineManagerID: e.value.userID,
                    }));
                  }}
                  options={lineManagersList}
                  optionLabel="displayName"
                  placeholder="Select Line Manager"
                  className={`tw-border tw-border-solid ${
                    formErrors.lineManager
                      ? "tw-border-red-600"
                      : "tw-border-gray-300"
                  } tw-rounded-md placeholder:tw-font-normal tw-w-full`}
                  filter
                />
              </div>
            </>
          )}

          <Button
            label={formType === "add" ? "Add User" : "Update User"}
            className="tw-flex tw-px-3 tw-py-2 tw-rounded-lg bg-primary border-primary tw-text-white tw-font-medium tw-w-full tw-mt-8"
            onClick={() => handleCheckRoleChanged(formType)}
            disabled={isAddButtonDisabled}
          />
        </div>
      </Dialog>

      <Dialog
        header="Extend Timesheet"
        visible={showExtendedTimesheet}
        draggable={false}
        style={{ width: "400px" }}
        onHide={() => {
          if (!showExtendedTimesheet) return;
          setShowExtendedTimesheet(false);
        }}
      >
        <div className="tw-grid tw-grid-cols-1 tw-gap-4 tw-w-full">
          <div className="tw-flex tw-flex-col tw-gap-2 tw-w-full">
            <label htmlFor="name">Name</label>
            <InputText
              id="name"
              value={extendTimeSheetData.name ?? ""}
              readOnly
              aria-describedby="name-help"
              className={`${
                extendTimeSheetFormErrors.name
                  ? "tw-border-red-600"
                  : "tw-border-gray-300"
              } tw-border tw-border-solid tw-border-[#D0D5DD] tw-py-[10px] tw-px-[14px] tw-w-full`}
            />
          </div>
          <div className="tw-flex tw-flex-col tw-gap-2 tw-w-full">
            <label htmlFor="buttondisplay" className="tw-font-bold tw-block">
              Week
            </label>
            <Calendar
              id="buttondisplay"
              value={extendTimeSheetWeek}
              dateFormat="dd-mm-yy"
              selectionMode="range"
              onChange={(e) => {
                setExtendTimeSheetFormErrors((prev: any) => ({
                  ...prev,
                  startDate: null,
                  endDate: null,
                }));
                handleWeekChange({
                  value: e.value as Date | null,
                  setExtendTimeSheetWeek,
                  setExtendTimeSheetData,
                  toast,
                });
              }}
              showIcon
              className={`${
                extendTimeSheetFormErrors.endDate
                  ? "tw-border-red-600"
                  : "tw-border-gray-300"
              } tw-border tw-border-solid tw-border-[#D0D5DD] tw-py-[10px] tw-px-[14px] tw-w-full tw-rounded-lg`}
            />
          </div>
          <div className="tw-flex tw-flex-col tw-gap-2 tw-w-full">
            <label htmlFor="buttondisplay" className="tw-font-bold tw-block">
              Extend timesheet Hours
            </label>
            <InputText
              value={extendTimeSheetData.extendHours ?? ""}
              onChange={(e) => {
                setExtendTimeSheetFormErrors((prev: any) => ({
                  ...prev,
                  extendHours: null,
                }));
                // Validate input: Allow only numbers from 1 to 48
                if (/^\d*$/.test(e.target.value)) {
                  // Check if the input is numeric
                  const numValue = Number(e.target.value);
                  if (numValue >= 1 && numValue <= 48) {
                    setExtendTimeSheetData((prev: any) => ({
                      ...prev,
                      extendHours: e.target.value,
                    }));
                  } else if (e.target.value === "") {
                    // Allow empty string
                    setExtendTimeSheetData((prev: any) => ({
                      ...prev,
                      extendHours: "",
                    }));
                  }
                }
              }}
              placeholder="Enter hours between 1 to 48"
              className={`${
                extendTimeSheetFormErrors.extendHours
                  ? "tw-border-red-600"
                  : "tw-border-gray-300"
              } tw-border tw-border-solid tw-border-[#D0D5DD] tw-py-[10px] tw-px-[14px] tw-w-full tw-rounded-lg`}
            />
          </div>
          <Button
            type="button"
            disabled={addExtendTimeSheetLoading}
            className="tw-bg-[#00AFEE] tw-flex tw-justify-center tw-text-white tw-py-3 tw-px-6 tw-rounded-lg tw-font-semibold tw-mt-4"
            onClick={async () => {
              if (!validateExtendTimeSheetForm()) return;
              await extendTimeSheet(
                extendTimeSheetData,
                setExtendTimeSheetData,
                setShowExtendedTimesheet,
                setExtendTimeSheetWeek,
                setExtendTimeSheetFormErrors,
                setAddExtendTimeSheetLoading,
                toast
              );
            }}
          >
            Submit
          </Button>
        </div>
      </Dialog>

      <Dialog
        header="Lock/Unlock Timesheet"
        visible={showTimesheetLockDialog}
        draggable={false}
        style={{ width: "450px" }}
        onHide={() => {
          if (!showTimesheetLockDialog) return;
          setShowTimesheetLockDialog(false);
          setSelectedTimesheetLockDates([]);
        }}
      >
        <div className="tw-grid tw-grid-cols-1 tw-gap-4 tw-w-full">
          <div className="tw-flex tw-flex-col tw-gap-2 tw-w-full">
            <label htmlFor="timesheet-lock-name">Name</label>
            <InputText
              id="timesheet-lock-name"
              value={timesheetLockData.name ?? ""}
              readOnly
              className="tw-border tw-border-solid tw-border-[#D0D5DD] tw-py-[10px] tw-px-[14px] tw-w-full tw-bg-gray-100"
            />
          </div>

          <div className="tw-flex tw-flex-col tw-gap-2 tw-w-full">
            <label className="tw-font-bold tw-block">Action</label>
            <div className="tw-flex tw-gap-4">
              <div className="tw-flex tw-items-center">
                <RadioButton
                  inputId="action-unlock"
                  name="action"
                  value="unlock"
                  onChange={(e) => setTimesheetLockAction(e.value)}
                  checked={timesheetLockAction === "unlock"}
                />
                <label htmlFor="action-unlock" className="tw-ml-2">
                  Unlock
                </label>
              </div>
              <div className="tw-flex tw-items-center">
                <RadioButton
                  inputId="action-lock"
                  name="action"
                  value="lock"
                  onChange={(e) => setTimesheetLockAction(e.value)}
                  checked={timesheetLockAction === "lock"}
                />
                <label htmlFor="action-lock" className="tw-ml-2">
                  Lock
                </label>
              </div>
            </div>
          </div>

          <div className="tw-flex tw-flex-col tw-gap-2 tw-w-full">
            <label
              htmlFor="timesheet-lock-date-range"
              className="tw-font-bold tw-block"
            >
              Select Date Range
            </label>
            <Calendar
              id="timesheet-lock-date-range"
              value={selectedTimesheetLockDates ?? []}
              dateFormat="dd-mm-yy"
              selectionMode="range"
              onChange={(e) => {
                const date = Array.isArray(e.value) ? e.value[0] : e.value;
                handleTimesheetLockDateChange(date);
              }}
              maxDate={new Date()}
              showIcon
              placeholder="Select any date in the week"
              readOnlyInput
              className={`${
                timesheetLockFormErrors.startDate ||
                timesheetLockFormErrors.endDate
                  ? "tw-border-red-600"
                  : "tw-border-gray-300"
              } tw-border tw-border-solid tw-border-[#D0D5DD] tw-py-[10px] tw-px-[14px] tw-w-full tw-rounded-lg`}
            />
            {/* {(timesheetLockFormErrors.startDate ||
              timesheetLockFormErrors.endDate) && (
              <small className="tw-text-red-600">
                {timesheetLockFormErrors.startDate ||
                  timesheetLockFormErrors.endDate}
              </small>
            )} */}
          </div>
          <Button
            type="button"
            disabled={timesheetLockLoading}
            icon={
              timesheetLockAction === "lock" ? "pi pi-lock" : "pi pi-unlock"
            }
            className={`tw-bg-[#00AFEE] tw-flex tw-justify-center tw-text-white tw-py-3 tw-px-6 tw-rounded-lg tw-font-semibold tw-mt-4 tw-gap-2`}
            onClick={handleTimesheetLockSubmit}
          >
            {timesheetLockLoading
              ? timesheetLockAction === "lock"
                ? "Locking..."
                : "Unlocking..."
              : timesheetLockAction === "lock"
              ? "Lock Timesheet"
              : "Unlock Timesheet"}
          </Button>
        </div>
      </Dialog>

      <Dialog
        header={`${
          pendingStatusChange?.isActive === 1 ? "Activate" : "Deactivate"
        } User`}
        draggable={false}
        visible={isStatusDialogVisible}
        style={{ width: "28vw" }}
        onHide={() => {
          setIsStatusDialogVisible(false);
          setStatusChangeReason("");
          setPendingStatusChange(null);
        }}
      >
        <div className="tw-flex tw-flex-col tw-gap-4">
          <p>
            Please provide a reason for{" "}
            {pendingStatusChange?.isActive === 1
              ? "activating"
              : "deactivating"}{" "}
            this user:
          </p>
          <InputText
            value={statusChangeReason}
            onChange={(e) => {
              setStatusChangeReason(e.target.value);
              setStatusChangeReasonError(null);
            }}
            placeholder="Enter reason..."
            className={`tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal ${
              statusChangeReasonError ? "tw-border-red-500" : ""
            }`}
          />
          {statusChangeReasonError && (
            <small className="tw-text-red-500">{statusChangeReasonError}</small>
          )}
          <div className="tw-flex tw-gap-2 tw-justify-end">
            <Button
              label="Cancel"
              className="tw-px-4 tw-py-2 tw-rounded-lg focus:tw-shadow-none tw-bg-gray-300 hover:tw-bg-gray-400 tw-text-gray-800 tw-font-medium"
              onClick={() => {
                setIsStatusDialogVisible(false);
                setStatusChangeReason("");
                setPendingStatusChange(null);
                setStatusChangeReasonError(null);
              }}
            />
            <Button
              label="Confirm"
              className="tw-px-4 tw-py-2 tw-rounded-lg focus:tw-shadow-none bg-primary border-primary hover:tw-bg-[#02a2db] tw-text-white tw-font-medium"
              onClick={confirmStatusChange}
              disabled={isAddButtonDisabled}
            />
          </div>
        </div>
      </Dialog>

      <Dialog
        className="comments-dialog tw-w-[444px]"
        style={{ maxWidth: "620px" }}
        header={() => {
          return (
            <div className="tw-flex tw-flex-col tw-justify-start tw-items-start tw-w-full">
              <span>Status Change History</span>
              <span>
                ({selectedRowData?.firstName} {selectedRowData?.lastName})
              </span>
            </div>
          );
        }}
        visible={viewHistoryPopup}
        draggable={false}
        onHide={() => {
          if (!viewHistoryPopup) return;
          setViewHistoryPopup(false);
        }}
      >
        <>
          {userStatusChangeActivity && userStatusChangeActivity.length !== 0 ? (
            <Timeline
              className="tw-p-4"
              align="left"
              marker={customizedMarker}
              content={customizedContent}
              value={events}
            />
          ) : (
            <div className="tw-p-4 tw-border-b tw-text-center tw-border-b-solid tw-border-b-[#DBDBDB]">
              <p className="tw-m-0 tw-text-sm tw-font-medium tw-text-[#64748B] tw-mb-2">
                No History Found
              </p>
            </div>
          )}
        </>
      </Dialog>
    </>
  );
};

export default AdminUserManagement;
